<lib-renderer-container
  [params]="params"
  [tooltip]="getDisplayValue()"
>
  {{ getDisplayValue() }}
</lib-renderer-container>
